"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index47.js");var r=e.fails,t=!r(function(){return Object.defineProperty({},1,{get:function(){return 7}})[1]!==7});exports.descriptors=t;
